export const BIG_LOGO_BASE64 = `
data:image/png;base64,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=
`;
